import Geocode from "react-geocode";
import { GOOGLE_API_KEY } from "../../../../config/Keys";

const google_API_Key = GOOGLE_API_KEY;
Geocode.setApiKey(google_API_Key);
Geocode.enableDebug();

export const GetAddressFromLatLng = async (newLat, newLng) => {
  console.log(newLat,newLng)
  let response = await Geocode.fromLatLng(newLat, newLng);
  console.log(response)

  return {
    place_id: response.results[0].place_id ? response.results[0].place_id : "",
    address: response.results[0].formatted_address
      ? response.results[0].formatted_address
      : "",
    city: getCity(response.results[0].address_components),
    area: getArea(response.results[0].address_components),
    state: getState(response.results[0].address_components),
    pinCode: getPinCode(response.results[0].address_components),
  };
};

export const getState = (addressArray) => {
  let state = "";
  for (let i = 0; i < addressArray.length; i++) {
    for (let i = 0; i < addressArray.length; i++) {
      if (
        addressArray[i].types[0] &&
        "administrative_area_level_1" === addressArray[i].types[0]
      ) {
        state = addressArray[i].long_name;
        return state;
      }
    }
  }
};

export const getPinCode = (addressArray) => {
  let pinCode = "";
  for (var j = 0; j < addressArray.length; j++) {
    for (var k = 0; k < addressArray[j].types.length; k++) {
      if (addressArray[j].types[k] === "postal_code") {
        pinCode = addressArray[j].long_name;
        return pinCode;
      }
    }
  }
};

export const getArea = (addressArray) => {
  let country = getCountry(addressArray);
  // IF COUNTRY === United States,
  // THEN AREA BECOMES CITY
  let area = "";
  if (country === "United States") {
    for (let i = 0; i < addressArray.length; i++) {
      if (
        addressArray[i].types[0] &&
        "administrative_area_level_2" === addressArray[i].types[0]
      ) {
        area = addressArray[i].long_name;
        return area;
      }
    }
  } else {
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0]) {
        for (let j = 0; j < addressArray[i].types.length; j++) {
          if (
            "sublocality_level_1" === addressArray[i].types[j] ||
            "locality" === addressArray[i].types[j]
          ) {
            area = addressArray[i].long_name;
            return area;
          }
        }
      }
    }
  }
};

export const getCity = (addressArray) => {
  let country = getCountry(addressArray);
  // IF COUNTRY === United States,
  // THEN CITY BECOMES AREA
  let city = "";
  if (country === "United States") {
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0]) {
        for (let j = 0; j < addressArray[i].types.length; j++) {
          if (
            "sublocality_level_1" === addressArray[i].types[j] ||
            "locality" === addressArray[i].types[j]
          ) {
            city = addressArray[i].long_name;
          }
        }
      }
    }
  } else {
    for (let i = 0; i < addressArray.length; i++) {
      if (
        addressArray[i].types[0] &&
        "administrative_area_level_2" === addressArray[i].types[0]
      ) {
        city = addressArray[i].long_name;
      }
    }
  }
  return city;
};

export const getCountry = (addressArray) => {
  let country = "";
  for (let i = 0; i < addressArray.length; i++) {
    if (addressArray[i].types[0] && "country" === addressArray[i].types[0]) {
      country = addressArray[i].long_name;
      return country;
    }
  }
};
